import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const addContactPerson = (user, schoolSpeciality, body) => {
  return requestWithPromise(`/api/school-specialities/${getIdOrNull(schoolSpeciality)}/contact-person`, HttpMethods.POST, body, user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const addMultipleContactPersons = (user, body) => apiClient.post(user, 'school-specialities/contact-persons', body)

export const createSchoolSpeciality = (schoolSpeciality, user) => {
  return requestWithPromise('/api/school-specialities',
    HttpMethods.POST,
    schoolSpeciality,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const deleteSchoolSpeciality = (schoolSpeciality, user) => {
  return requestWithPromise(
    `/api/school-specialities/${schoolSpeciality.id}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const getAllSchoolSpeciality = user => {
  return requestWithPromise('/api/school-specialities',
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json?.data) {
      return json.data
    }
  })
}

export const getContactPersonsSchoolSpeciality = (schoolSpeciality, user) => {
  return requestWithPromise(`/api/school-specialities/${schoolSpeciality.id}/contact-persons`, HttpMethods.GET, null, user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const updateSchoolSpeciality = (schoolSpeciality, body, user) => {
  return requestWithPromise(
    `/api/school-specialities/${schoolSpeciality.id}`,
    HttpMethods.PATCH,
    body,
    user
  )
}
